import flatpickr from "flatpickr"
import css from 'flatpickr/dist/flatpickr.css';
const Norwegian = require("flatpickr/dist/l10n/no.js").default.no;
import axios from "axios";

export default {
    name      : 'datepicker',
    init() {
        const containers = document.querySelectorAll('input[name="dates"]');

        if (!containers.length) {
            return;
        }
        const host = document.querySelector('[name="site_root"]').content;
        const resource = document.querySelector('#js_theProduct').dataset.resource;
        const productId = document.querySelector('#js_theProduct').dataset.productId;

        containers.forEach(container => {
            flatpickr(container, {
                "locale": Norwegian,
                mode: "range",
                minDate: "today",
                maxDate: new Date().fp_incr(365),
                onOpen: function(selectedDates, dateStr, instance) {    
                    axios.get(`${host}/actions/mm/bookings/get-future-bookings?productId=${productId}&resource=${resource}&force=purge`)
                        .then(response => {
                            instance.set('disable', response.data);     
                            console.log(response.data);        
                        })
                        .finally(data => {
                            instance.calendarContainer.classList.add('flatpickr-loaded');
                        });
                   
                },
                onChange (selectedDates, value, datepicker) {
                    if (selectedDates.length === 2) {
                        let diffTime = Math.abs(selectedDates[1] - selectedDates[0]);
                        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
                        let addDays = Math.max(0, 1 - diffDays);
                
                        if (addDays > 0) {
                            selectedDates[1].setDate(selectedDates[1].getDate() + addDays);
                            datepicker.setDate(selectedDates);
                            setTimeout(() => {
                                datepicker.jumpToDate(selectedDates[0]);
                                datepicker.open();
                            });
                        }
                    }
                }
            });
        });
        
      
    }
}

